<template>
  <div class="seachdata">
    <div class="top"></div>
    <van-calendar
      ref="calendar"
      v-model="show"
      type="range"
      left="5465465"
      @confirm="onConfirm"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <div class="seach">
      <div class="time" @click="show= true">{{endtime?starttime+'~'+endtime:"时间范围"}}</div>
      <input
        :style="{width:(endtime?'40%':'')}"
        type="text"
        v-model="seach"
        placeholder="游戏名称/单位/著作人/版号/文号"
        ref="inputseach"
        @input="init"
        @keypress="searchGoods"
        @keyup.13="init"
      />
      <div class="qc" v-show="seach.length != 0" @click="seach = ''">
        <van-icon name="close" size="0.4rem" color="#ccc" />
      </div>
      <div class="icons" @click="getseach">
        <img class="seachimg" src="../assets/icon-seach.png" alt />
      </div>
    </div>
    <div class="ls" v-if="!seach">
      <div class="title clearfix">
        <span>历史记录</span>
        <img src="../assets/icon-del.png" alt @click="del" />
      </div>
      <div class="content" v-if="history.length != 0">
        <div
          class="box"
          v-for="(item,index) in history"
          :key="index"
          @click="gethistory(item)"
        >{{item}}</div>
      </div>
      <div v-else style="text-align:center;margin-top:50px;color:#999">暂无搜索历史~~</div>
    </div>
    <div class="lxss" v-if="seach && (isflage || articleList.length != 0)">
      <div class="loadd" v-if="isflage">
        <div class="loader4"></div>
      </div>
      <div
        class="box"
        v-for="(item,index) in articleList"
        :key="index"
        @click="getdetalis(item.datatype,item.gamename)"
      >
        <span
          class="bs"
          :style="{color:(item.datatype == '出版单位'?'#597EF7':item.datatype == '著作人'?'#FF4D4F':item.datatype == '运营单位'?'#FA8C16':item.datatype == '出版物号'?'#EB2F96':item.datatype == '文号'?'#7CB305':''),background:(item.datatype == '出版单位'?'rgba(89,126,247,0.1)':item.datatype == '著作人'?'rgba(255,77,79,0.1)':item.datatype == '运营单位'?'rgba(250,140,22,0.1)':item.datatype == '出版物号'?'rgba(196,29,127,0.1)':item.datatype == '文号'?'rgba(124,179,5,0.1)':'')}"
        >{{item.datatype}}</span>
        <div class="conss">
          {{item.gamename.split(seach)[0]}}
          <span style="color:#999999">{{seach}}</span>
          {{item.gamename.split(seach)[1]}}
        </div>
        <img src="../assets/icon-hc.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from "vant/lib/calendar";
import "vant/lib/calendar/style";
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";
export default {
  data() {
    return {
      seach: "",
      timer: null,
      articleList: [],
      history: [],
      isflage: true,
      show: false,
      date: "",
      starttime: "",
      endtime: "",
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2021, 0, 31),
      formatter(day) {
        const month = day.date.getMonth() + 1;
        const date = day.date.getDate();

        if (month === 5) {
          if (date === 1) {
            day.topInfo = "劳动节";
          } else if (date === 4) {
            day.topInfo = "青年节";
          } else if (date === 11) {
            day.text = "今天";
          }
        }

        if (day.type === "start") {
          day.bottomInfo = "入住";
        } else if (day.type === "end") {
          day.bottomInfo = "离店";
        }

        return day;
      },
    };
  },
  watch: {
    show: function (val, old) {
      if (val == true) {
        if (document.querySelector(".qingkong")) {
        } else {
          this.$nextTick(() => {
            this.settiem();
          });
        }
      }
    },
  },
  components: {
    vanCalendar: Calendar,
    vanIcon: Icon,
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
    },
    // 日期格式化
    formdata(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.starttime = this.formdata(start);
      this.endtime = this.formdata(end);
      this.date = `${this.formatDate(start)}~${this.formatDate(end)}`;
      this.getseach();
    },
    //   模糊搜索
    init() {
      this.articleList = [];
      const vm = this;
      // 输入框防抖
      this.isflage = true;
      clearTimeout(vm.timer);
      vm.timer = setTimeout(function () {
        // 切换为搜索
        let parmas = {
          name: vm.seach,
          starttime: vm.starttime,
          endtime: vm.endtime,
        };
        vm.$http
          .post("api/game/GetGameIsbnDataWithType", parmas)
          .then((res) => {
            vm.articleList = res.data.Data.List;
            vm.isflage = false;
          });
      }, 1000);
    },
    searchGoods(event) {
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.getseach();
      }
    },
    // 前往搜索
    getseach() {
      if (this.seach != "") {
        this.history.push(this.seach);
        this.history = [...new Set(this.history)];
        localStorage.setItem("history", this.history);
      }
      this.$router.push({
        path: "/",
        query: {
          seach: this.seach,
          name: this.seach,
          starttime: this.starttime,
          endtime: this.endtime,
        },
      });
    },
    // 删除历史
    del() {
      localStorage.removeItem("history");
      this.history = [];
    },
    // 历史跳转
    gethistory(val) {
      this.$router.push({
        path: "/",
        query: {
          name: val,
          starttime: this.starttime,
          endtime: this.endtime,
        },
      });
    },
    // 前往详情页
    getdetalis(type, name) {
      this.history.push(name);
      this.history = [...new Set(this.history)];
      localStorage.setItem("history", this.history);
      this.$router.push({
        path: "/",
        query: this.seachcl(type, name),
      });
    },
    seachcl(type, name) {
      let data = {
        著作人: "authorname",
        出版单位: "pubunitname",
        运营单位: "saleunit",
        游戏: "gamename",
        出版物号: "seach",
        文号: "seach",
      };
      let obj = {
        starttime: this.starttime,
        endtime: this.endtime,
        name: name,
      };
      obj[data[type]] = name;
      return obj;
    },
    // 清空日期
    deltirm() {
      this.$refs.calendar.reset();
      this.date = "";
      this.starttime = "";
      this.endtime = "";
      this.show = false;
      this.getseach();
    },
    // 时期快捷键
    datetirm(val) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * val);
      this.starttime = this.formdata(start);
      this.endtime = this.formdata(end);
      this.getseach();
    },
    // 生成日期清空快捷键并绑定事件
    settiem() {
      let tit = document.querySelector(".van-calendar__header-title");
      // 父级盒子
      var kuaijie = document.createElement("div");
      kuaijie.classList.add("kuaijie");
      // 清空日期
      var div2 = document.createElement("div");
      div2.innerText = "清空日期";
      div2.classList.add("qingkong");

      // 近一个月
      var oneyue = document.createElement("div");
      oneyue.innerText = "最近一个月";
      kuaijie.appendChild(oneyue);
      // 近三个月
      var theryue = document.createElement("div");
      theryue.innerText = "最近三个月";
      kuaijie.appendChild(theryue);

      // 近半年
      var banyear = document.createElement("div");
      banyear.innerText = "最近半年";
      kuaijie.appendChild(banyear);
      kuaijie.appendChild(div2);

      oneyue.addEventListener("click", this.datetirm.bind(this, 1));
      theryue.addEventListener("click", this.datetirm.bind(this, 3));
      banyear.addEventListener("click", this.datetirm.bind(this, 6));
      div2.addEventListener("click", this.deltirm);
      tit.appendChild(kuaijie);
    },
  },
  mounted() {
    if (this.$route.query.type == 3) {
      this.$refs["inputseach"].focus();
    } else if (this.$route.query.type == 2) {
      this.show = true;
    }
  },
  created() {
    this.history = localStorage.getItem("history")
      ? localStorage.getItem("history").split(",")
      : [];
    this.starttime = this.$route.query.starttime || "";
    this.endtime = this.$route.query.endtime || "";
    this.seach = this.$route.query.name || "";
    this.isflage = false;
  },
};
</script>

<style lang="scss" scoped>
.loader4 {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 0px;
  border-radius: 100%;
  border: 2px solid;
  border-top-color: #ccc;
  border-bottom-color: rgba(0, 0, 0, 0.1);
  border-left-color: #ccc;
  border-right-color: rgba(0, 0, 0, 0.1);
  -webkit-animation: loader4 1s ease-in-out infinite;
  animation: loader4 1s ease-in-out infinite;
  position: absolute;
  left: 45%;
  top: 45%;
}
@keyframes loader4 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader4 {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.loadd {
  height: 80px;
  width: 100%;
  position: relative;
}
.seachdata {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  // overflow-y: scroll;
  background: #f5f6f5;
  .seach {
    width: 351px;
    height: 42px;
    background: rgba(255, 255, 255, 1);
    border-radius: 21px;
    margin: 0 auto;
    margin-top: 16px;
    overflow: hidden;
    position: relative;
    .time {
      float: left;
      height: 42px;
      //   width: 180px;
      max-width: 180px;
      min-width: 80px;
      line-height: 42px;
      margin-left: 12px;
      font-size: 15px;
      padding-right: 15px;
      box-sizing: border-box;
      font-weight: 400;
      color: rgba(2, 163, 213, 1);
      position: relative;
      &:before {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: 17px;
        // transform: translateY(-50%);
        // 　　left: 0px;
        right: 4px;
        border-top: solid 5px transparent;
        border-left: solid 5px rgba(2, 163, 213, 1);
        border-bottom: solid 5px transparent;
        transform: rotate(90deg);
      }
    }

    .qc {
      width: 30px;
      height: 42px;
      position: absolute;
      right: 40px;
      top: 0;
      background-color: #fff;
      z-index: 2000;
      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .icons {
      width: 50px;
      //   float: right;
      height: 42px;
      position: absolute;
      right: 0px;
      top: 0;

      .seachimg {
        width: 16px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    input {
      width: 65%;
      min-width: 100px;
      height: 100%;
      padding: 0 16px;
      float: left;
      box-sizing: border-box;
      font-size: 15px;
      font-weight: 400;
      // color: rgba(204, 204, 204, 1);
      box-sizing: border-box;
    }
    input[type="text"]:focus {
      outline: none; // 如何把蓝色去掉？
      border: none; // 如何改成别的颜色？
    }
    input::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      font-size: 12px;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
  }
  .top {
    position: fixed;
    top: 0;
    width: 100%;
    height: 4px;
    background: rgba(2, 163, 213, 1);
  }
  .ls {
    padding: 0 12px;
    box-sizing: border-box;
    .title {
      margin-top: 10px;
      span {
        display: inline-block;
        float: left;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
      }
      img {
        float: right;
        width: 16px;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .box {
        width: 109px;
        height: 32px;
        margin-top: 12px;
        background: rgba(238, 238, 238, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 32px;
        text-align: center;
        padding: 0 8px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .box:last-child:nth-child(3n - 1) {
        margin-right: calc(30% + 8% / 2);
      }
    }
  }
  .lxss {
    margin-top: 12px;
    width: 100%;
    padding-bottom: 12px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    .box {
      width: 351px;
      //   border-radius: 16px;
      margin: 0 auto;

      height: 40px;
      line-height: 40px;
      padding: 0 12px;
      box-sizing: border-box;
      border-bottom: 1px solid #eee;
      span {
        display: inline-block;
        float: left;
      }
      .conss {
        width: 70% !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        float: left;
        span {
          font-size: 14px;
          width: auto !important;
          //   max-width: 50%;
          float: none;
        }
      }
      .bs {
        margin-top: 8px;
        padding: 3px 4px;
        text-align: center;
        line-height: 18px;
        background: rgba(54, 207, 201, 0.1);
        border-radius: 2px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(19, 194, 194, 1);
        margin-right: 6px;
      }
      span:nth-child(2) {
        width: 240px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }

      img {
        width: 16px;
        height: 16px;
        margin-top: 12px;
        float: right;
      }
    }
  }
}
</style>